import React, { startTransition, useEffect, useMemo, useRef, useState } from 'react'
import './StaticPage.scss'
import { mainApi } from '../../../store/services/mainApi'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  Container,
  FormControlLabel,
  IconButton,
  Modal,
  Typography,
  useMediaQuery,
  Badge,
  styled,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Dashboard } from './Dashboard/Dashboard'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'
import { StaticOrder } from '../StaticOrder/StaticOrder'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DeliveryIcon } from '../../../pages/components/assets/deliveryCarOff.svg'
import { ReactComponent as PickupIcon } from '../../../pages/components/assets/pickupoff.svg'
import i18n from '../../../Localize';
import dayjs from 'dayjs'

import { useLocation, useNavigate, useParams } from 'react-router'
import { useSelector } from 'react-redux'
import DataGridTable from '../StaticOrder/DataGridTable/DataGridTable'
import searchActive from '../../components/assets/images/Search_active.png'
import AlbaranModal from './AlbaranModal/AlbaranModal'
import FacturaDownloadModal from '../components/FacturaDownloadModal/FacturaDownloadModal'
import IvaPriceSwitch from '../../../components/IvaPriceSwitch/IvaPriceSwitch'
import { downloadAlbaranPdfs, MAX_BULK_ALBARAN_DOWNLOADS } from '../../../utils/downloadAlbaranPdfs'
import { dedupeOrdersById, getOrderRowAmounts, sumOrdersTotals } from '../../../utils/orderTotals'

const PAYMENT_TOLERANCE_CENTS = 1
const parseAmount = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (typeof value === 'string') {
    const normalized = value.replace(/\s/g, '').replace(',', '.')
    const parsed = Number(normalized)
    return Number.isFinite(parsed) ? parsed : 0
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}
const toCents = (value) => Math.round(parseAmount(value) * 100)
const isPaidWithTolerance = (total, paid) => toCents(paid) >= toCents(total) - PAYMENT_TOLERANCE_CENTS
const isPaidBalanceAligned = (paid, balance) => Math.abs(toCents(paid) - toCents(balance)) <= PAYMENT_TOLERANCE_CENTS

const filterMonthList = [
    {value: '1', title: 'Jan',},
    {value: '2', title: 'Feb',},
    {value: '3', title: 'Mar',},
    {value: '4', title: 'Apr',},
    {value: '5', title: 'May',},
    {value: '6', title: 'Jun',},
    {value: '7', title: 'Jul',},
    {value: '8', title: 'Aug',},
    {value: '9', title: 'Sep',},
    {value: '10', title: 'Oct',},
    {value: '11', title: 'Nov',},
    {value: '12', title: 'Dec',},
  ]
  const filterYearList = [
    {value: '2026', title: '2026'},
    {value: '2025', title: '2025'},
    {value: '2024', title: '2024'},
  ]

export default function StaticPage() {
  const [tradeName, setTradeName] = useState('')
  const navigate = useNavigate()
  const { t } = useTranslation()
  const mobileView = useMediaQuery('(max-width: 798px)')

  const [vpfOrders, setVpfOrders] = useState([])

  const [viewOrder, setViewOrder] = useState(false)
  const [viewOrderId, setViewOrderId] = useState('')

  // // table switcher
  const urlParams = new URLSearchParams(window.location.search);
  const facturasQuerry = urlParams.get('facturas');
  const location = useLocation()
  const [tableType, setTableType] = useState(facturasQuerry == 1 ? false : location.pathname.split('/').includes('facturas') ? false : true)
  const [openAlbaranModal, setOpenAlbaranModal] = useState(null)
  const tableRef = useRef(null)

  
  // //clone modal
  // const [cloneModal, setCloneModal] = useState(false)
  const tradeNameParams = useParams()?.tradeName ;
  const {
    data: contact,
    isLoading,
    isError,
    refetch
  } = mainApi.useGetBuisnessContactByTradeNameQuery(location.pathname.split('/').pop(), {
    skip: !location.pathname.split('/').pop(),
  })

  useEffect(() => {
    if (isError) {
      refetch()
    }
  }, [isError])

  const {
    data: facturas,
    isLoading: isLoadingFacturas,
    isFetching: isFetchingFacturas,
  } = mainApi.useGetFacturasByClientQuery(
    { tradeName: contact?.tradeName },
    {
      skip: !contact,
    },
  )
  useEffect(() => {
      if (facturasQuerry == 1 && !isLoading) {
        setTimeout(() => {
          tableRef.current?.scrollIntoView();
        }, 200)
      }
      if (location.pathname.split('/').includes('facturas')  && !isLoading) {
        setTimeout(() => {
          tableRef.current?.scrollIntoView();
        }, 200)
      }
  }, [tableType, isLoadingFacturas]);
  
  const [openDummy, setOpenDummy] = useState(false)
  const [facturaDownloadRow, setFacturaDownloadRow] = useState(null)
  const [pdfName, setPdfName] = useState('')

  const setValuesForPdf = (value) => {
    console.log('[StaticPage] factura for PDF generation:', value)
    setOpenDummy(true)
    setPdfName(`${value.cliente}/${value.fetcha.toISOString()}.pdf`)
    setFacturaDownloadRow({
      ...value,
      orders: value.orders,
      fetcha: value.fetcha,
      accountKey: value?.accountKey || 'ADM',
    })
  }

  const [facturasRowData, setFacturasRowData] = useState([])

  useEffect(() => {
    if (facturas && !isLoadingFacturas && !isFetchingFacturas) {
      console.log('[StaticPage] facturas (raw):', facturas)
      const rows = facturas?.map((factura) => ({
        ...factura,
        id: factura._id,
        fetcha: new Date(factura.fetcha),
      }))
      console.log('[StaticPage] facturas (rows):', rows)
      setFacturasRowData(rows)
    }
  }, [facturas, isLoadingFacturas, isFetchingFacturas])

  const usr = JSON.parse(localStorage.getItem('acc'))

  const [updateFacturaUpdate] =
    mainApi.useUpdateFacturaUpdateFieldMutation()
  const handleSendUpdateField = (id) => {
    const userName = usr?.name ? usr.name : 'Unknown'
    updateFacturaUpdate({
      id: id,
      userName: userName,
    })
  }

  const [facturasCount, setFacturasCount] = useState([])
  const [rowSelectionModel, setRowSelectionModel] = useState([])
  const [bulkAlbaranLoading, setBulkAlbaranLoading] = useState(false)
  const [bulkAlbaranProgress, setBulkAlbaranProgress] = useState(null)
  const [bulkBarExpanded, setBulkBarExpanded] = useState(true)
  const [bulkDownloadFormat, setBulkDownloadFormat] = useState('pdf')
  const priceWithIva = useSelector((state) => state.contextUI.PriceIVA)
  const [rows, setRows] = useState([])
  const [filterValue, setFilterValue] = useState('')
  const [filterYearValue, setFilterYearValue] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const filtredRows = useMemo(() => {
    const selectedMonth = filterValue || new Date().getMonth() + 1 // Если месяц не выбран, используем текущий
    const selectedYear = new Date().getFullYear() // Можно также добавить фильтр по году, если нужно=
    return rows
      ?.filter((row) => {
        if (!filterValue) return true
        try {
          if (row.deliveryDate !== undefined) {
            const date = row.deliveryDate?.split(',')[0];
            const month = parseInt(date?.split('.')[1]);
            // console.log(month);
            return month == filterValue
          } else {
            return false
          }
        } catch (error) {
          return false
        }
      })
      ?.filter((row) => {
        if (!filterYearValue) return true
        try {
          if (row.deliveryDate !== undefined) {
            const date = row.deliveryDate?.split(',')[0];
            const year = parseInt(date?.split('.')[2]);
            console.log(row);
            return year == filterYearValue
          } else {
            return false
          }
        } catch (error) {
          return false
        }
      })
      ?.filter((row) => {
        if (!searchValue) return true
        try {
          if (row.deliveryDate !== undefined) {
            return row.deliveryDate.toLowerCase().includes(searchValue.toLowerCase()) ||
              row.idT.toLowerCase().includes(searchValue.toLowerCase()) ||
              row.total.toString().includes(searchValue) ||
              row.items.some(el => el?.name?.toLowerCase()?.includes(searchValue.toLowerCase()))
          } else {
            return false
          }
        } catch (error) {
          return false
        }
      })
      ?.filter((row) => {
        if (row?.status._id === '65ea14fef2ce5f8bdbb131ab' || row?.status._id === '660eb916a99b60113aedfdc0') {
          return false
        } else {
          return true
        }
      })
  }, [rows, filterValue, filterYearValue, searchValue])
  const findOrder = (orderId) => {
    console.log(filtredRows.find((el) => el._id == orderId));
    return filtredRows.find((el) => el._id == orderId)
  }

  const facturasColumns = [
    {
      field: '_id',
      headerName: '',
      width: mobileView ? 50 : 50,
      renderCell: (params) => {
        return (
          <input type="checkbox" onChange={(e) => {
            console.log(params.row);
            if ([...facturasCount].includes(params.value)) {
              setFacturasCount(facturasCount?.filter((el) => el == params))
              setRowSelectionModel(rowSelectionModel?.filter((el) => !params.row.orders?.includes(el?._id)))
            } else {
              setFacturasCount([...facturasCount, params.value])
              setRowSelectionModel([...rowSelectionModel, ...params.row.orders.map((el) => findOrder(el))])
            }
          }}
          checked={[...facturasCount].includes(params.value)} />
        )
      }
    },
    {
      field: 'fetcha',
      headerName: 'Fecha',
      width:  mobileView ? 100 : 150,
      type: 'date',
      renderCell: (params) => (
        <div>{dayjs(params.value).format('DD/MM/YYYY')}</div>
      )
    },
    { 
      field: 'num',
      headerName: 'Num',
      width:  mobileView ? 100 : 150,
      editable: true
    },
    {
      field: 'status',
      headerName: 'Status',
      width: mobileView ? 100 : 150,
      renderCell: (params) => {
        return (
          <div
            style={{
              backgroundColor: params.value?.color,
              borderRadius: '10px',
              padding: '5px 0px',
              color: '#fff',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {params.value?.name}
          </div>
        )
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: mobileView ? 160 : 160,
      renderCell: (params) => (
        <Box>
          <Button
            onClick={(e) => {
              e.stopPropagation()
              handleSendUpdateField(params.row.id)
              setValuesForPdf(params.row)
            }}
            size='small'
            variant='contained'
            sx={{ m: 1 }}
          >
            <DownloadIcon color={'white'}/>
            {t('StaticPage.tableHeaders.download')}
          </Button>
        </Box>
      ),
    },
    { 
      field: 'total',
      headerName: 'Total',
      type: 'number',
      width: 100,
      renderCell: (params) => `${parseAmount(params?.row?.total).toFixed(2)} €`
    },
    {
      field: 'payValue',
      headerName: 'Paid',
      width: mobileView ? 100 : 100,
      renderCell: (params) => {
        const paidValue = parseAmount(params?.value)
        const totalValue = parseAmount(params?.row?.total)
        const isPaid = isPaidWithTolerance(totalValue, paidValue) || paidValue > totalValue
        return (
          <span style={{color: isPaid ? '#5FC56E' : 'red' }}>
            {paidValue.toFixed(2)} €
          </span>
        )
      },
    },
  ]

  const { data: orders, isLoading: isLoadingOrders } = mainApi.useGetOrdersByTradeNameQuery(tradeName, {
    skip: !tradeName,
  })
  useEffect(() => {
    if (tradeName === null || tradeName === undefined) {
      console.log('tradeName is null or undefined.')
    } else if (tradeName === 'VPF') {
      fetch('https://tpomobi.shop/getOrdersAdmin?tradeName=VPF', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((json) => {
          if (json === null || json === undefined) {
            console.log('json is null or undefined.')
          } else {
            setVpfOrders(json)
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    }
  }, [tradeName])

  useEffect(() => {
    if (contact) {
      // document.title = `${contact.name}`
      const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
      favicon.rel = 'icon'
      favicon.href = `${contact.img}`
      document.head.appendChild(favicon)
    }
  }, [contact])

  // useEffect(() => {
  //   console.log(vpfOrders, 'vpfOrders')
  // }, [vpfOrders])

  

  useEffect(() => {
    if (contact) {
      setTradeName(contact?.tradeName || '')
      document.title = contact?.name ? contact?.name + `(${contact?.tradeName ? contact?.tradeName : 'N/A'})` : 'Static Page'
      // console.log(contact)
    }
  }, [contact])
  const tableContainerRef = useRef();



  useEffect(() => {
    if (tradeName === 'VPF') {
      if (vpfOrders && vpfOrders?.length > 0) {
        const updatedRows = vpfOrders?.filter((el) => el?.status?._id !== '658ecc88a340ccc96acae78d')?.map((item) => {
          const amounts = getOrderRowAmounts(item)
          return {
            ...item,
            id: item._id,
            idT: item.idTucomida ? item.idTucomida : item._id ? item._id.slice(-6) : 'N/A',
            date: new Date(item.date),
            total: amounts.total,
            balance: amounts.balance,
          }
        })
        setRows(updatedRows)
      }
    } else {
      if (orders) {
        const updatedRows = orders?.filter((el) => el?.status?._id !== '658ecc88a340ccc96acae78d')?.map((item) => {
          const amounts = getOrderRowAmounts(item)
          return {
            ...item,
            id: item._id,
            idT: item.idTucomida ? item.idTucomida : item._id ? item._id.slice(-6) : 'N/A',
            date: new Date(item.date),
            total: amounts.total,
            balance: amounts.balance,
          }
        })
        setRows(updatedRows)
      }
      // }
    }
  }, [orders, tradeName, vpfOrders])

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 10,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));

  const [columns, setColumns] = useState([
    {
      field: 'deliveryDate',
      headerName: t('StaticPage.tableHeaders.date'),

      width: mobileView ? 100 : 150, // Set a specific width for mobile view

      renderCell: (params) => {
        console.log(params)
        return (
          <p 
            style={{ width: '100%' }}
            title={params?.row ? params.row.orderDeliveryType == 'pickup' ? 'Pick up' : params.row.orderDeliveryType == 'delivery' ? 'Delivery' : 'no info' : ''}
          >
            {
            params?.value ? 
              (params.value?.includes('PLT') ? params?.value?.split(',')[0] + ' 🌙' : params?.value?.split(',')[0] + '☀️') 
              : new Date(params.value).toLocaleDateString()
            } 
            {params?.row ? params.row.orderDeliveryType == 'pickup' ? <PickupIcon /> : params.row.orderDeliveryType == 'delivery' ? <DeliveryIcon /> : 'no info' : ''}
          </p>
        )
      },
    },
    {
      field: 'idT',
      headerName: t('StaticPage.tableHeaders.id'),

      width: mobileView ? 100 : 150, // Set a specific width for mobile view
      renderCell: (params) => {
        // console.log(params);
        return (
          <StyledBadge badgeContent={params.row.items?.length} color="primary" sx={{ width: '95%'}}>
            <Typography
              sx={{
                fontFamily: 'Inter',
                width: '100%',
                border: '1px solid white',
                display: 'flex',
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '5px 5px',
                marginTop: '5px',
                textAlign: 'center',
                fontWeight: 'bold',
                borderRadius: '5px',
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                backgroundColor: '#1976D2',
                transition: 'all 0.5s ease',
                color: '#fff',

                '&:hover': {
                  backgroundColor: '#4fa0f0',
                  color: '#000',
                },
              }}
              onClick={(e) => {
                e.stopPropagation() // Предотвращаем всплытие события
                // Затем установите ID для модального окна, используя правильное свойство
                setViewOrderId(params.row._id) // или params.row.id.orderId, если id - это объект
                setViewOrder(true) // Открываем модальное окно
              }}
            >
              {params.value || 'N/A'}
            </Typography>
          </StyledBadge>
        )
      },
    },
    {
      field: 'status',
      headerName: t('StaticPage.tableHeaders.status'),
      width: mobileView ? 100 : 150,

      renderCell: (params) => {
        return (
          <div
            style={{
              backgroundColor: params.value?.color,
              borderRadius: '10px',
              padding: '5px 0px',
              color: '#fff',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {params?.value?.name ? params.value.name : 'Nuevo pedido'}
          </div>
        )
      },
    },
    {
      field: 'id',
      headerName: t('StaticPage.tableHeaders.actions'),
      width: mobileView ? 160 : 160, // Set a specific width for mobile view
      renderCell: (params) => (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            size='small'
            variant='contained'
            sx={{ m: 1 }}
            onClick={() => {
              setOpenAlbaranModal(params.row)
            }}
          >
            {t('StaticPage.tableHeaders.pdf')}
          </Button>
        </Box>
        {params.row.status.name == 'Emitido' && 
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            size='small'
            variant='contained'
            sx={{ m: 1, minWidth: 'fit-content' }}
            onClick={() => {
              console.log(params);
              // window.open(`order/${params.row.id}`, '_blank')
            }}
          >
            {t('StaticPage.tableHeaders.download')}
          </Button>
        </Box>}</div>
      ),
    },
    {
      field: 'total',
      headerName: t('StaticPage.tableHeaders.total'),

      width: mobileView ? 100 : 100, // Set a specific width for mobile view

      renderCell: (params) => {
        return <p style={{ width: '100%', textAlign: 'center' }}>{parseFloat(params?.value)?.toFixed(2) || 'N/A'}€</p>
      },
    },
    {
      field: 'paidValue',
      headerName: t('StaticPage.tableHeaders.paid'),
      width: mobileView ? 100 : 100, // Set a specific width for mobile view
      renderCell: (params) => {
        const paidValue = parseAmount(params?.value)
        const balanceValue = parseAmount(params?.row?.balance)
        const isPaid =
          isPaidBalanceAligned(paidValue, balanceValue) ||
          isPaidWithTolerance(params?.row?.total || 0, paidValue) ||
          balanceValue > paidValue
        return (
          <span style={{ fontFamily: 'Inter', width: '100%', textAlign: 'center',
            color: isPaid ? 'green' : (paidValue === 0 ? 'black' : '#51dd51') }} 
            // className='AccountScroll__items'
            >
            {params?.value ? parseFloat(params?.value)?.toFixed(2) : '0.00'} €
          </span>
        )
      },
    },
    {
      field: 'balance',
      headerName: t('StaticPage.tableHeaders.balance'),

      width: 100, // Set a specific width for mobile view
      renderCell: (params) => {
        const balanceValue = parseAmount(params?.value)
        const paidValue = parseAmount(params?.row?.paidValue)
        const isPaid =
          isPaidBalanceAligned(paidValue, balanceValue) ||
          isPaidWithTolerance(params?.row?.total || 0, paidValue) ||
          balanceValue > paidValue
        const displayBalance = isPaid && balanceValue > 0 ? 0 : balanceValue
        return (
          <span 
            style={{ 
              fontFamily: 'Inter',
              textAlign: 'center',
              width: '100%', 
              color: isPaid ? 'green' : 'red'
            }} 
            className='AccountScroll__items'
          >
            {displayBalance.toFixed(2)}€
          </span>
        )
      },
    },
    // {
    //   field: 'idShare',
    //   headerName: t('StaticPage.tableHeaders.actions'),
    //   width: mobileView ? 120 : 120, // Set a specific width for mobile view
    //   renderCell: (params) => (
        
    //   ),
    // },
  ])

  // const [facturasColumns, setFacturasColumns] = useState([
  //   {
  //     field: 'id',
  //     headerName: 'ID',
  //     width: 100,
  //   },
  // ])

  //selection
  

  const selectedOrders = useMemo(
    () => dedupeOrdersById(rowSelectionModel),
    [rowSelectionModel],
  )

  const { total, paid, balance } = useMemo(
    () => sumOrdersTotals(selectedOrders),
    [selectedOrders],
  )

  const bulkDownloadCount = Math.min(selectedOrders.length, MAX_BULK_ALBARAN_DOWNLOADS)
  const bulkDownloadOverLimit = selectedOrders.length > MAX_BULK_ALBARAN_DOWNLOADS

  const ordersWithoutFacturas = useMemo(() => {
    const facturaOrderIds = facturasRowData.flatMap((item) => item.orders ?? [])
    return filtredRows.filter((order) => !facturaOrderIds.includes(order._id))
  }, [filtredRows, facturasRowData])

  const allPendingAlbaranesSelected = useMemo(() => {
    if (!ordersWithoutFacturas.length) return false
    const selectedIds = new Set(selectedOrders.map((o) => o._id))
    return ordersWithoutFacturas.every((row) => selectedIds.has(row._id))
  }, [ordersWithoutFacturas, selectedOrders])

  const somePendingAlbaranesSelected = useMemo(() => {
    if (!selectedOrders.length || !ordersWithoutFacturas.length) return false
    const selectedIds = new Set(selectedOrders.map((o) => o._id))
    const selectedCount = ordersWithoutFacturas.filter((row) => selectedIds.has(row._id)).length
    return selectedCount > 0 && selectedCount < ordersWithoutFacturas.length
  }, [ordersWithoutFacturas, selectedOrders])

  const handleSelectAllPendingAlbaranes = () => {
    const pendingIds = new Set(ordersWithoutFacturas.map((o) => o._id))

    if (allPendingAlbaranesSelected) {
      setRowSelectionModel(rowSelectionModel.filter((o) => !pendingIds.has(o._id)))
      return
    }

    const existing = rowSelectionModel.filter((o) => !pendingIds.has(o._id))
    setRowSelectionModel([...existing, ...ordersWithoutFacturas])
  }

  const handleBulkDownloadAlbarans = async () => {
    if (!selectedOrders.length || bulkAlbaranLoading) return

    setBulkAlbaranLoading(true)
    setBulkAlbaranProgress({ current: 0, total: bulkDownloadCount })

    try {
      const { downloaded, errors, truncated, skipped } = await downloadAlbaranPdfs(
        selectedOrders,
        priceWithIva,
        {
          onProgress: ({ current, total }) => setBulkAlbaranProgress({ current, total }),
          tradeNameFallback: tradeName,
          format: bulkDownloadFormat,
        },
      )

      if (truncated) {
        alert(
          `Límite: ${MAX_BULK_ALBARAN_DOWNLOADS} albaranes por descarga. Descargados: ${downloaded}. Omitidos: ${skipped}.`,
        )
      } else if (errors.length) {
        alert(`Descargados: ${downloaded}. Errores: ${errors.length}`)
      }
    } catch (err) {
      alert(err?.message || 'Error al descargar albaranes')
    } finally {
      setBulkAlbaranLoading(false)
      setBulkAlbaranProgress(null)
    }
  }

  //month filters
  


  const handleFilterChange = (e) => {
    setFilterValue(e.target.value)
  }



  

  const { 
    data: contacts, 
    isLoading: isLoadingContacts,
  } = mainApi.useGetContactClientByTradeNameQuery(tradeNameParams.replace(/[0-9]/g, ''), {
    skip: !tradeNameParams,
  })

  const isNY25 = useParams()?.tradeName == 'NY25' ? true : false

  useEffect(() => {
    if (isNY25) {
      navigate('/category/NY25')
    }
  }, [isNY25])

  

  return isLoading || isError ? (
    <Container>
      <CircularProgress />
    </Container>
  ) : (
    <div className='staticPage'>
      <AlbaranModal
        open={openAlbaranModal !== null}
        onClose={() => setOpenAlbaranModal(null)}
        selectedOrder={openAlbaranModal}
        tradeNameFallback={tradeName}
      />
      <FacturaDownloadModal
        open={openDummy}
        onClose={() => setOpenDummy(false)}
        facturaRow={facturaDownloadRow}
        pdfName={pdfName}
      />
      <Box
        className='staticPage__header'
        sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row' }}
      >
        <Typography
          className='staticPage__header__title'
          variant='h3'
          sx={{ textAlign: 'left', fontFamily: 'Archivo Black', m: 2, color: '#176318', textTransform: 'uppercase' }}
        >
          {contact?.name}
        </Typography>
        <LanguageSwitcher />
      </Box>
      {mobileView ? (
        <Button
          sx={{
            m: 2,
            width: mobileView ? '200px' : '250px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: 'Archivo Black',
            background: '#5FC56E',
            borderRadius: '8px'
          }}
          variant='contained'
          onClick={() => { 
            navigate(`/category/${tradeName}`)
          }}
          // color='success'
        >
          {t('StaticPage.btn.newOrder')}
        </Button>
      ) : null}
      <Dashboard contact={contact} orders={filtredRows} scrollList={filtredRows} tableContainerRef={tableContainerRef}/>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row', gap: '10px' }}>
        <Button
          sx={{
            m: 2,
            width: mobileView ? '200px' : '250px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: 'Archivo Black',
            background: '#5FC56E',
            borderRadius: '8px'
          }}
          variant='contained'
          onClick={() => { 
            navigate(`/category/${tradeName}`)
          }}
          // color='success'
        >
          {t('StaticPage.btn.newOrder')}
        </Button>
        <Box sx={ {display: 'flex', flexDirection: 'column'}}>
          <div className='staticPage__filterOrders' style={{ borderRadius: '6px 6px 0px 0px', flexWrap: 'noWrap'}}>
            <button 
              onClick={() => {setFilterYearValue(''); setFilterValue('')}} 
              className={filterYearValue == '' && filterValue == '' ? 'active' : ''} 
              style={{padding: '0px 10px', }}
            >
              All
            </button>
            {filterYearList.map((el) => 
            <button 
              key={el.title}
              onClick={() => setFilterYearValue(el.value)} 
              className={filterYearValue == el.value ? 'active' : ''} 
              style={{padding: '0px 10px'}}
            >
              {el.title}
            </button>)}
          </div>
          <div className='staticPage__filterOrders' style={{ borderRadius: '0px 6px 6px 6px'}}>
            {filterMonthList.map((el) => 
            <button 
              key={el.title}
              onClick={() => setFilterValue(el.value)}
              className={filterValue == el.value ? 'active' : ''}
            >
              {el.title}
            </button>)}
          </div>
        </Box>
        <div className='staticPage__search'>
          <input value={searchValue} onChange={(e) => setSearchValue(e.target.value)}/>
          <img src={searchActive}/>
        </div>
      </Box>
        <DataGridTable
          getRowId={(row) => row.sku}
          checkboxSelection
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel)
          }}
          rowSelectionModel={rowSelectionModel}
          selectAllVisible={{
            checked: allPendingAlbaranesSelected,
            indeterminate: somePendingAlbaranesSelected,
            onToggle: handleSelectAllPendingAlbaranes,
          }}
          ref={tableContainerRef}
          ordersRows={filtredRows}
          ordersColumns={columns}
          facturasRows={facturasRowData}
          facturasColumns={facturasColumns} 
          fontSize={mobileView ? 12 : 15}
        />
      
      <Modal open={viewOrder} onClose={() => setViewOrder(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: mobileView ? '300px' : '900px',
            height: 'auto',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            padding: 2,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          <StaticOrder orderId={viewOrderId} />
        </Box>
      </Modal>

      {(filtredRows?.length > 0 || selectedOrders.length > 0) && (
        <Box
          sx={{
            position: 'fixed',
            bottom: bulkBarExpanded ? { xs: 16, sm: 24 } : { xs: 8, sm: 12 },
            left: '50%',
            transform: 'translateX(-50%)',
            width: bulkBarExpanded ? { xs: '94%', sm: 'auto' } : '40px',
            maxWidth: bulkBarExpanded ? 960 : '40px',
            bgcolor: 'background.paper',
            borderRadius: bulkBarExpanded ? 2 : 1.5,
            boxShadow: bulkBarExpanded ? 24 : 8,
            border: bulkBarExpanded ? '1px solid black' : '1px solid #d0d0d0',
            zIndex: 1200,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: bulkBarExpanded ? 1 : 0.25,
              px: bulkBarExpanded ? 1.5 : 0.75,
              py: bulkBarExpanded ? 0.75 : 0.25,
              minHeight: bulkBarExpanded ? 44 : 28,
              cursor: 'pointer',
              borderBottom: bulkBarExpanded ? '1px solid #e8e8e8' : 'none',
            }}
            onClick={() => setBulkBarExpanded((prev) => !prev)}
          >
            <Typography
              noWrap
              sx={{
                fontFamily: 'Inter',
                fontSize: bulkBarExpanded ? '14px' : '12px',
                fontWeight: 600,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {bulkBarExpanded ? (
                selectedOrders.length > 0
                  ? `${selectedOrders.length} ${t('StaticPage.modal.selected')}`
                  : 'Selecciona pedidos para descargar albaranes'
              ) : selectedOrders.length > 0 ? (
                `${selectedOrders.length}·${balance?.toFixed(2)}€`
              ) : (null)}
            </Typography>
            <IconButton
              size="small"
              sx={{ p: bulkBarExpanded ? 0.5 : 0, ml: bulkBarExpanded ? 0 : -0.25 }}
              onClick={(e) => {
                e.stopPropagation()
                setBulkBarExpanded((prev) => !prev)
              }}
              aria-label={bulkBarExpanded ? 'Ocultar panel' : 'Mostrar panel'}
            >
              {bulkBarExpanded ? (
                <ExpandMoreIcon sx={{ fontSize: 20 }} />
              ) : (
                <ExpandLessIcon sx={{ fontSize: 16 }} />
              )}
            </IconButton>
          </Box>

          <Collapse in={bulkBarExpanded}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                padding: 2,
                pt: 1.5,
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                fontSize: '14px',
              }}
            >
              {selectedOrders.length > 0 ? (
                <>
                  <Typography sx={{ fontFamily: 'Inter' }}>
                    Total: {total?.toFixed(2)}€
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: paid?.toFixed(2) !== 0 ? 'green' : 'black',
                    }}
                  >
                    Paid: {paid?.toFixed(2)}€
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: balance?.toFixed(2) == 0 ? 'green' : 'red',
                    }}
                  >
                    Balance: {balance?.toFixed(2)}€
                  </Typography>
                  {facturasCount?.length !== 0 && (
                    <Typography sx={{ fontFamily: 'Inter' }}>
                      Facturas: {facturasCount?.length}
                    </Typography>
                  )}
                </>
              ) : (null)}

              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={allPendingAlbaranesSelected}
                    indeterminate={somePendingAlbaranesSelected}
                    onChange={handleSelectAllPendingAlbaranes}
                    disabled={!ordersWithoutFacturas.length}
                  />
                }
                label="Seleccionar todos"
                sx={{
                  fontFamily: 'Inter',
                  mr: 0,
                  ml: { xs: 0, sm: 0.5 },
                  '& .MuiFormControlLabel-label': { fontSize: '14px' },
                }}
              />

              <IvaPriceSwitch compact sx={{ ml: { sm: 1 } }} />

              <ToggleButtonGroup
                value={bulkDownloadFormat}
                exclusive
                size="small"
                disabled={bulkAlbaranLoading}
                onChange={(_, value) => value && setBulkDownloadFormat(value)}
                aria-label="Formato de descarga"
                sx={{
                  '& .MuiToggleButton-root': {
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    textTransform: 'none',
                    px: 1.5,
                  },
                }}
              >
                <ToggleButton value="pdf">PDF</ToggleButton>
                <ToggleButton value="jpeg">JPEG</ToggleButton>
              </ToggleButtonGroup>

              <Button
                size="small"
                variant="contained"
                disabled={!selectedOrders.length || bulkAlbaranLoading}
                startIcon={
                  bulkAlbaranLoading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <DownloadIcon />
                  )
                }
                onClick={handleBulkDownloadAlbarans}
                sx={{
                  backgroundColor: '#5FC56E',
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                {bulkAlbaranLoading && bulkAlbaranProgress
                  ? `Albaranes ${bulkAlbaranProgress.current}/${bulkAlbaranProgress.total}`
                  : bulkDownloadOverLimit
                    ? `Descargar albaranes (${bulkDownloadCount}/${selectedOrders.length}, máx. ${MAX_BULK_ALBARAN_DOWNLOADS})`
                    : `Descargar albaranes (${selectedOrders.length})`}
              </Button>
            </Box>
          </Collapse>
        </Box>
      )}
    </div>
  )
}
